<template>
<div id="app" :style="{'font-size':fontSize + 'px'}">
  <div class="global">
    <div class="tool">
      <h1 class="title">BLAZR</h1>
      <p>Cherche un <span class="highlight">blaze</span> de <select class="num-selection" v-model.number="numLetters"><option v-for="index in 9">{{index}}</option></select> {{numLetters > 1 ? 'lettres' : 'lettre'}}</p>
      <div class="letters-wrapper">
      <div class="letters">
        <div class="letter-wrapper" v-for="letter in numLetters" @click="toggleLock(letter-1)" :class="{'lock':letters[letter-1].lock}">
          <input class="letter" v-model="letters[letter-1].value" maxlength="1">
        </div>
      </div>
      <div class="heart" :class="{'loved':isLoved}" @click.prevent.stop="love">&#10084;</div>
      </div>
      <div class="button" @click="generate">Chercher</div>
    </div>
    <div class="heart-title" v-show="loveList.length">&#10084;</div>
    <label-list class="love" :list="loveList"></label-list>
  </div>
</div>
</template>

<script>
import LabelList from './components/LabelList.vue'
export default {
  name: 'app',
  components: {
    'label-list': LabelList
  },
  computed: {
    fontSize() {
      return this.width < 640 ? this.width / 640 * 1.3 : 1
    },
    current() {
      return this.letters.map((letter) => {
        return letter.value.toUpperCase()
      }).join('')
    },
    isLoved() {
      return this.loveList.indexOf(this.current) > -1
    }
  },
  data() {
    return {
      width:0,
      numLetters: 5,
      loveList: [],
      letters: [{
        'value': 'H',
        'lock': false
      }, {
        'value': 'E',
        'lock': false
      }, {
        'value': 'L',
        'lock': false
      }, {
        'value': 'L',
        'lock': false
      }, {
        'value': 'O',
        'lock': false
      }]
    }
  },
  mounted() {
    let storedLoveList = window.localStorage['blazr-love-list'],
        loveList = storedLoveList ? JSON.parse(storedLoveList) : []
    loveList.map((loved) => {this.loveList.push(loved)})
    window.onresize = this.onResize
    this.onResize();
  },
  methods: {
    generate() {
      this.letters.map((letter, index) => {
        if (!letter.lock) {
          letter.value = this.randomLetter()
        }
      })
    },
    toggleLock(index) {
      this.letters[index].lock = !this.letters[index].lock
    },
    randomLetter() {
      return String.fromCharCode(Math.floor(Math.random() * 26 + 65))
    },
    love() {
      if (this.isLoved) return
      this.loveList.push(this.current)
    },
    onResize() {
      this.width = window.innerWidth
    }
  },
  watch: {
    numLetters(value, oldValue) {
      let i = 0
      this.letters = []
      while (i < value) {
        this.$set(this.letters, i++, {
          'value': this.randomLetter(),
          'lock': false
        })
      }
    },
    loveList(value, oldValue) {
      window.localStorage.setItem('blazr-love-list', JSON.stringify(value))
    }
  }
}
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  display: flex;
  width: 100%;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

#app .global {
  font-size: 21em;
}

#app .global,
#app input {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: 'Imprima', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app .highlight {
  color: #3DD2CC;
}

#app .title {
  font-family: 'Cabin Sketch', cursive;
  font-size: 4em;
  margin: 0.5em 0;
  color: #3DD2CC;
}

#app .num-selection {
  font-size: 1em;
}

#app .letters-wrapper {
  position: relative;
  display: block;
  margin-top:1.5em;
}

#app .letters {
  display: inline-block;
  margin-left:2em;
}

#app .letter-wrapper {
  position: relative;
  display: inline-block;
}

#app .letter-wrapper:after {
  content: " \1F512";
  margin-top: 0.4em;
  display: block;
  cursor: pointer;
  opacity: 0.4;
  font-size: 1em;
}

#app .letter-wrapper.lock:after {
  opacity: 1;
}

#app .letter {
  display: inline-block;
  width: 2em;
  height: 2em;
  text-transform: uppercase;
  text-align: center;
  font-size: 1em;
  box-sizing: border-box;
}

#app .heart {
  display: inline-block;
  vertical-align: top;
  margin-top: 0.2em;
  margin-left: 0.4em;
  font-size: 1.3em;
  cursor: pointer;
  opacity: 0.6;
}

#app .heart.loved {
  color: red;
  opacity: 1;
}

#app .button {
  display: inline-block;
  margin: auto;
  color: white;
  background-color: #3DD2CC;
  border-radius: 0.2em;
  margin: 1.5em;
  padding: 0.8em;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 1em;
  user-select: none;
}

#app .heart-title {
  font-size: 1em;
  color:#d0d0d0;
  margin: 1em 0;
}
#app .heart-title::after, #app .heart-title::before {
  content:'';
  display: inline-block;
  margin:0 1.2vw;
  width:5vw;
  height:0.5em;
  vertical-align: top;
  border-bottom:1px solid #d0d0d0;
}
</style>



// WEBPACK FOOTER //
// App.vue?41ae229d